/**
 * Conceptos estáticos: el monto de ficha no se prorratea ni se recalcula.
 * En agrario, la única excepción es 0201 (asignación familiar): sí se calcula.
 */

export const CODIGO_PLAME_ASIGNACION_FAMILIAR = '0201';

export function normalizarCodigoPlame(valor) {
  const s = String(valor ?? '').trim();
  if (!s) return '';
  const digits = s.replace(/\D/g, '');
  if (digits) return digits.padStart(4, '0');
  return s.toUpperCase();
}

export function esAsignacionFamiliarPlame(codigo) {
  return normalizarCodigoPlame(codigo) === CODIGO_PLAME_ASIGNACION_FAMILIAR;
}

export function esRegimenAgrarioValor(valor) {
  const s = String(valor ?? '').trim().toLowerCase();
  if (!s) return false;
  return s === 'agri' || s.includes('agrario');
}

/** Código o nombre del régimen (RG, PRIVAD, MINGEN, etc. no son agrario). */
export function esRegimenAgrarioDeEmpleado({ codigo, nombre, regimenSeleccionado } = {}) {
  const extra = regimenSeleccionado || {};
  return (
    esRegimenAgrarioValor(codigo)
    || esRegimenAgrarioValor(nombre)
    || esRegimenAgrarioValor(extra.codigo)
    || esRegimenAgrarioValor(extra.nombre)
  );
}

/**
 * ¿Este ingreso está en la config de conceptos estáticos de la empresa?
 * Compara por id PLAME y por código (0201 vs 201, string/número).
 */
export function conceptoEstaEnEstaticos(lista, concepto) {
  const items = Array.isArray(lista) ? lista : [];
  if (!concepto || items.length === 0) return false;

  const plameId = Number(
    concepto.plame_configuracion?.id
    ?? concepto.plame_configuracion_id
    ?? concepto.id_concepto_plame
    ?? 0
  );
  const codigo = normalizarCodigoPlame(
    concepto.plame_configuracion?.codigo_plame
    ?? concepto.codigo_plame
    ?? concepto.codigo
    ?? concepto.codigoPlame
  );

  return items.some((estatico) => {
    const idEst = Number(
      estatico.id_concepto_plame
      ?? estatico.plame_configuracion_id
      ?? estatico.plame_configuracion?.id
      ?? 0
    );
    if (plameId && idEst && plameId === idEst) return true;
    const codigoEst = normalizarCodigoPlame(
      estatico.codigo ?? estatico.codigo_plame ?? estatico.plame_configuracion?.codigo_plame
    );
    return Boolean(codigo && codigoEst && codigo === codigoEst);
  });
}

/**
 * Conserva el monto de ficha si el concepto es estático.
 * En agrario, 0201 sí se calcula/prorratea; el resto de estáticos se conserva.
 */
export function debeConservarMontoEstaticoFicha(esEstatico, esRegimenAgrario, codigoPlame) {
  if (!esEstatico) return false;
  if (esRegimenAgrario && esAsignacionFamiliarPlame(codigoPlame)) return false;
  return true;
}

